module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.value.show),
      callback: function($$v) {
        _vm.value.show = $$v
      },
      expression: "value.show"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "ls-modal-header"
  }, [_c('button', {
    attrs: {
      "data-dismiss": "modal",
      "close-modal": ""
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "ls-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('customers.modal_inactive.inactive_subscriber')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-body"
  }, [_c('div', {
    staticClass: "ls-alert-warning"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('application.alert.warning')))]), _vm._v(" " + _vm._s(_vm.$t('customers.modal_inactive.inactive_warning')) + "\n      ")]), _vm._v(" "), (_vm.customer) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('customers.modal_inactive.inactive_confirm', {
        customer: _vm.customer.name
      }))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-footer"
  }, [_c('button', {
    staticClass: "ls-btn",
    attrs: {
      "data-dismiss": "modal",
      "close-modal": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.close')))]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn-danger ls-float-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.destroyResource()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.inactive')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-741bb5ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/customers/components/ModalInactive.vue
// module id = 803
// module chunks = 1